import React, { useState, useEffect } from "react";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TablePagination from "@material-ui/core/TablePagination";
import Paper from "@material-ui/core/Paper";
import Timezone from "../../commons/timezone/Timezone.js";
import * as ConstantsMedidor from "../unidadMedidor/constants.js";
import * as Utils from "../../commons/utils/Utils";

// Histórico de registros de kilometraje de la llanta (llanta_kilometros), VEC-3964.

const PER_PAGE = 10;
const COLUMNAS = 7;

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#1a1036",
    color: theme.palette.common.white,
    fontFamily: "'Poppins', sans-serif",
  },
  body: {
    fontSize: 12,
    fontFamily: "'Poppins', sans-serif",
  },
}))(TableCell);

const LlantaRegistrosKmGrid = (props) => {
  const { llanta, intl } = props;
  const [registros, setRegistros] = useState([]);
  const [recapadas, setRecapadas] = useState(llanta.recapadas || 0);
  const [unidadMedidorId, setUnidadMedidorId] = useState(llanta.unidad_medidor_id);
  const [pagination, setPagination] = useState({ page: 0, count: 0, perPage: PER_PAGE });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    cargar(0);
  }, []);

  const cargar = (page) => {
    setLoading(true);
    Utils.getData(`/llantaodometro/${llanta.id}/registros?page=${page}&perPage=${PER_PAGE}`)
      .then((data) => {
        setRegistros(data.registros);
        setRecapadas(data.llanta.recapadas);
        setUnidadMedidorId(data.llanta.unidad_medidor_id);
        setPagination(data.pagination);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  };

  const noAplica = () =>
    intl.formatMessage({ id: "llantaRegistrosKmGrid.render.no_aplica", defaultMessage: "No aplica" });

  const unidad = () => {
    if (unidadMedidorId === ConstantsMedidor.ID__UM_ODOMETRO) {
      return intl.formatMessage({ id: "llantaOdometroGrid.render.label_unidad_medidor_odometro", defaultMessage: "kms" });
    }
    if (unidadMedidorId === ConstantsMedidor.ID__UM_HOROMETRO) {
      return intl.formatMessage({ id: "llantaOdometroGrid.render.label_unidad_medidor_horometro", defaultMessage: "hrs" });
    }
    return "";
  };

  const conUnidad = (valor) => (valor === null || valor === undefined ? "-" : `${valor} ${unidad()}`.trim());

  const motivo = (origen) => {
    switch (origen) {
      case "alta_manual":
        return intl.formatMessage({ id: "llantaRegistrosKmGrid.motivo.alta_manual", defaultMessage: "Alta de la llanta" });
      case "alta_importacion":
        return intl.formatMessage({ id: "llantaRegistrosKmGrid.motivo.alta_importacion", defaultMessage: "Alta de la llanta por importación" });
      case "edicion_manual":
        return intl.formatMessage({ id: "llantaRegistrosKmGrid.motivo.edicion_manual", defaultMessage: "Edición del odómetro desde la llanta" });
      case "montaje":
        return intl.formatMessage({ id: "llantaRegistrosKmGrid.motivo.montaje", defaultMessage: "Montaje / asignación a un móvil" });
      case "cambio_medidor":
        return intl.formatMessage({ id: "llantaRegistrosKmGrid.motivo.cambio_medidor", defaultMessage: "Cambio de medidor" });
      case "actualizacion_km_movil":
        return intl.formatMessage({ id: "llantaRegistrosKmGrid.motivo.actualizacion_km_movil", defaultMessage: "Actualización de km del móvil" });
      case "actualizacion_km_revertida":
        return intl.formatMessage({ id: "llantaRegistrosKmGrid.motivo.actualizacion_km_revertida", defaultMessage: "Actualización de km del móvil (revertida)" });
      case "reset_km_movil":
        return intl.formatMessage({ id: "llantaRegistrosKmGrid.motivo.reset_km_movil", defaultMessage: "Corrección de kilometraje (reset)" });
      default:
        return origen;
    }
  };

  return (
    <React.Fragment>
      <TableContainer component={Paper}>
        <Table aria-label="registros de kilometraje">
          <TableHead>
            <TableRow>
              <StyledTableCell align="center">
                {intl.formatMessage({ id: "llantaRegistrosKmGrid.column.fecha", defaultMessage: "Fecha y Hora" })}
              </StyledTableCell>
              <StyledTableCell align="center">
                {intl.formatMessage({ id: "llantaRegistrosKmGrid.column.movil", defaultMessage: "Móvil" })}
              </StyledTableCell>
              <StyledTableCell align="center">
                {intl.formatMessage({ id: "llantaRegistrosKmGrid.column.usuario", defaultMessage: "Usuario" })}
              </StyledTableCell>
              <StyledTableCell align="center">
                {intl.formatMessage({ id: "llantaRegistrosKmGrid.column.odometro", defaultMessage: "Odómetro" })}
              </StyledTableCell>
              <StyledTableCell align="center">
                {intl.formatMessage({ id: "llantaRegistrosKmGrid.column.odometro_recapado", defaultMessage: "Odómetro Recapado" })}
              </StyledTableCell>
              <StyledTableCell align="center">
                {intl.formatMessage({ id: "llantaRegistrosKmGrid.column.odometro_movil", defaultMessage: "Odómetro Móvil" })}
              </StyledTableCell>
              <StyledTableCell align="center">
                {intl.formatMessage({ id: "llantaRegistrosKmGrid.column.motivo", defaultMessage: "Motivo" })}
              </StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {!loading && registros.length === 0 && (
              <TableRow>
                <StyledTableCell align="center" colSpan={COLUMNAS}>
                  {intl.formatMessage({
                    id: "llantaRegistrosKmGrid.render.sin_registros",
                    defaultMessage: "No hay registros para mostrar",
                  })}
                </StyledTableCell>
              </TableRow>
            )}
            {registros.map((registro) => (
              <TableRow key={registro.id}>
                <StyledTableCell align="center">
                  {Timezone.getDateForClient(registro.fecha, null, "YYYY-MM-DD HH:mm:ss")}
                </StyledTableCell>
                <StyledTableCell align="center">{registro.movil || noAplica()}</StyledTableCell>
                <StyledTableCell align="center">
                  {registro.usuario ||
                    intl.formatMessage({
                      id: "llantaRegistrosKmGrid.render.proceso_automatico",
                      defaultMessage: "Proceso automático",
                    })}
                </StyledTableCell>
                <StyledTableCell align="center">{conUnidad(registro.odometro)}</StyledTableCell>
                <StyledTableCell align="center">
                  {recapadas > 0 ? conUnidad(registro.odometro_recapado) : "-"}
                </StyledTableCell>
                <StyledTableCell align="center">
                  {registro.movil ? conUnidad(registro.km_movil) : noAplica()}
                </StyledTableCell>
                <StyledTableCell align="center">{motivo(registro.origen)}</StyledTableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[PER_PAGE]}
        component="div"
        count={pagination.count}
        rowsPerPage={PER_PAGE}
        page={pagination.page}
        onChangePage={(event, newPage) => cargar(newPage)}
      />
    </React.Fragment>
  );
};

export default LlantaRegistrosKmGrid;
